export var PlayerSearchTimeType;
(function (PlayerSearchTimeType) {
    PlayerSearchTimeType[PlayerSearchTimeType["CREATED_AT"] = 1] = "CREATED_AT";
    PlayerSearchTimeType[PlayerSearchTimeType["LAST_LOGIN_AT"] = 2] = "LAST_LOGIN_AT";
})(PlayerSearchTimeType || (PlayerSearchTimeType = {}));
//# sourceMappingURL=PlayerSearchTimeType.js.map